import { StarFavoriteIcon } from '@/components/icons/StarFavoriteIcon';
import { useAddFavoritePool } from '@/hooks/queries/usePoolQueries';
import { PoolStatus } from '@/types/pool';
import { User } from '@/types/user';
import { isInvestor } from '@/utils/user';
import PoolStatusPill from '../PoolStatusPill';

type PoolCardHeaderProps = {
  poolId: number;
  status: PoolStatus;
  counterOffer?: boolean;
  className?: string;
  user: User | null;
  isFavorite?: boolean;
};

export function PoolCardHeader({
  poolId,
  status,
  counterOffer,
  className = '',
  user,
  isFavorite = false,
}: PoolCardHeaderProps) {
  const addFavoritePoolMutation = useAddFavoritePool();
  const handleAddFavoritePool = (ev: React.MouseEvent<HTMLSpanElement>) => {
    ev.stopPropagation();
    ev.preventDefault();
    addFavoritePoolMutation.mutate({ poolId, isFavorite: !isFavorite });
  };

  return (
    <div className={`flex justify-between items-center ${className}`}>
      <PoolStatusPill status={status} isInvestor={isInvestor(user)} counterOffer={counterOffer} />
      {isInvestor(user) && (
        <StarFavoriteIcon onClick={handleAddFavoritePool} selected={isFavorite} className="w-6 h-6" />
      )}
    </div>
  );
}
